var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"inline-block px-4 py-1 font-medium rounded-full",class:_vm.statusClass},[_vm._v(_vm._s(_vm.displayText))])
}
var staticRenderFns = []

export { render, staticRenderFns }